import { css } from '@emotion/css';

// 지도 SDK에 넘기는 DOM 마커에 className으로 지정하므로 클래스 문자열로 정의한다.
export const marker = css`
    align-items: center;
    background-color: var(--color-white);
    border-radius: var(--radius-full);
    color: var(--color-text-secondary);
    column-gap: var(--spacing-1);
    display: flex;
    font-size: var(--font-size-body-long);
    font-weight: bold;
    height: 32px;
    line-height: 1.4;
    padding: var(--spacing-1) var(--spacing-2);
    white-space: nowrap;
`;

export const cluster = css`
    align-items: center;
    background: var(--color-white);
    border-radius: 50%;
    color: var(--color-text-secondary);
    cursor: pointer;
    display: flex;
    font-size: var(--font-size-body-long);
    font-weight: bold;
    justify-content: center;
`;

export const location = css`
    align-items: center;
    display: flex;
    flex-direction: column;
    row-gap: 4px;
`;

export const locationText = css`
    background-color: #121212;
    border-radius: 4px;
    color: var(--color-white);
    font-size: 14px;
    font-weight: bold;
    line-height: 20px;
    padding: 2px 8px;
`;
